import React from 'react'
import { Paper, CircularProgress, Grid } from '@material-ui/core'

const APILoadingSpinnerRenderer = ({ isTable, colspan, styles, withoutPaper }) => {
  const tdLoadingContainerStyles = {
    textAlign: 'center',
    height: '400px'
  }

  const divLoadingContainerStyles = { textAlign: 'center' }

  const spinnerStyles = { marginTop: '20%' }

  return (
    <React.Fragment>
      {withoutPaper ? (
        <Grid item xs={12} style={divLoadingContainerStyles}>
          <CircularProgress data-testid="circular-progress" style={spinnerStyles} />
        </Grid>
      ) : (
        isTable ? (
          <tr>
            <td style={tdLoadingContainerStyles} colSpan={colspan}>
              <CircularProgress />
            </td>
          </tr>
        ) : (
          <Paper style={{ ...styles, ...divLoadingContainerStyles }} elevation={0}>
            <CircularProgress data-testid="no-table-circular-progress" style={spinnerStyles} />
          </Paper>
        )
      )}
    </React.Fragment>
  )
}

export default APILoadingSpinnerRenderer
